<template>
  <transition name="fades">
    <div class="leon-loading" style="z-index: 9999" @mousewheel.prevent @scroll.stop.prevent>
      <div class="lottie">
        <lottie :options="defaultOptions" :height="80" :width="80" v-on:animCreated="handleAnimation"/>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">

import Lottie from '@public/lottie.vue'
import * as animationData from '@assets/data/data.json'

export default {
  name: 'LeonLoading',
  data () {
    return {
      defaultOptions: {animationData: animationData}
    }
  },
  mounted () {
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    },
    btn () {
      this.$_Loading.close()
    }
  },
  components: {
    Lottie
  }
}
</script>
<style lang="scss" scoped>
.leon-loading{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  .lottie{
    width: 100px;
    height: 100px;
  }
}
body{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/plugin/LeonLoading/src/main.vue